<!-- 组织机构管理-->

<template>
  <div class="c-profile-content">

    <ul class="c-consulting-service">
      <li v-for="(item,index) in mypublish" :key="index">
        <div class="c-consulting-left">
          <h4>{{item.title}}</h4>
          <P>{{item.projectdetail}}</p>
          <p><a class="c-gs" href="javascript:;"><img src="../../assets/main/gongsibay@2x.png">{{item.projecttype==0?'服务':'产品'}}</a>发布时间：{{item.createTime}}</P>
        </div>
        <a href="javascript:;" class="view-response-btn" @click="show(item)">{{item.commentstars<=0?'评价':'查看评价'}}</a>
      </li>
    </ul>
    <el-dialog title="评价" :visible.sync="showRate" :before-close="handleClose">
      <div style="text-align: center;margin-bottom:20px ;">
        <el-rate v-model="rform.stars" show-text :texts="texts"></el-rate>
      </div>
       <div style="text-align: center;">
         <el-input type='textarea' v-model="rform.comment" auto-complete="off" :rows="5"
  placeholder="请输入评价内容"></el-input>
       </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="showRate = false">取 消</el-button>
        <el-button @click="rateProject()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import {
    getMyProjects,
    projectcomment
  } from '@/api/project.js'
  import {
    Rate,
    Dialog,
    Button,
    Input,
    Popconfirm,
    Form,
    FormItem,
  } from 'element-ui'

  export default {
    name: 'MutualEvaluation',
    props: {},
    components: {
      [Rate.name]: Rate,
      [Dialog.name]: Dialog,
      [Button.name]: Button,
      [Form.name]: Form,
      [FormItem.name]: FormItem,
      [Input.name]: Input,
      [Popconfirm.name]: Popconfirm,

    },
    data() {
      return {
        mypublish: [],
        formLabelWidth: '180px',
        rform: {
          stars: 3,
          comment: ''
        },
        showRate: false,
        texts: ['极差', '失望', '一般', '满意', '非常满意'],
        rpid: 0
      }
    },
    computed: {},
    mounted() {
      this.queryMyPublish()
    },
    methods: {
      show(item) {
        this.rpid = item.pid
        this.showRate = true
        if(item.commentstars>0){
          this.shows(item)
        }
      },
      shows(item){
        this.rform.stars = item.commentstars
        this.rform.comment = item.commenttext
      },
      rateProject() {
        let params = {
          pid: this.rpid,
          stars: this.rform.stars,
          comment: this.rform.comment
        }
        this.$http.post(projectcomment(),params).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.$message.success("评论成功")
            this.showRate = false
          } else {
            this.$message.success("评论失败")
          }
        });
      },
      handleClose(){
        this.rform.stars = 3
        this.rform.comment = ''
        this.rpid = 0
        this.showRate = false
      },
      queryMyPublish() {
        this.$http.get(getMyProjects()).then((res) => {
          console.log(res);
          if (res.code === 1) {
            this.mypublish = res.data
          } else {
            this.mypublish = []
          }
        });
      },
    }
  };
</script>

<style>
  @import url(./policyadvisory.css);
</style>
